"use strict";

// eslint-disable-next-line no-empty-function
module.exports = function () {};



//////////////////
// WEBPACK FOOTER
// /~/es5-ext/function/noop.js
// module id = 2010
// module chunks = 0